import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/ui/list/index.js